<template>
  <div class="mobile-b-page" @click="pageClick">
    <!-- 按 375x768 设计稿整体缩放，保持不同安全区下一屏完整展示 -->
    <div class="mb-stage">
      <!-- 轮播层只包含相册和人物，文案及操作区域保持常驻 -->
      <div class="mb-carousel">
        <div
          class="mb-slide"
          v-for="(slide, i) in slides"
          :key="i"
          :class="{ active: i === index }"
        >
          <img
            class="mb-gallery"
            :src="slide.gallery"
            :style="slide.galleryPos"
            alt=""
          />
          <img
            class="mb-hero"
            :src="slide.hero"
            :style="slide.heroPos"
            alt=""
          />
        </div>
      </div>

      <!-- 固定内容层 -->
      <img class="mb-title" :src="title" alt="" />
      <div class="mb-deco-fruit"></div>
      <div class="mb-subtitle"></div>
      <div class="mb-catalog"></div>

      <!-- 顶部：logo + 联系方式 -->
      <div class="mb-logo"></div>
      <div class="mb-contact-list" v-if="contactItems.length">
        <button
          v-for="item in contactItems"
          :key="item.type"
          class="hotspot mb-contact-button"
          :class="item.type"
          type="button"
          :aria-label="item.label"
          @click.stop="jumpUrl(item.url)"
        ></button>
      </div>
      <!-- 底部：立即下载 -->
      <div class="mb-download-actions">
        <button
          class="hotspot mb-download-button"
          type="button"
          aria-label="立即下载"
          @click.stop="downloadByType(os.isPhone ? 'ios' : 'android', $event)"
        ></button>
      </div>
    </div>
    <!-- 安卓提示框 -->
    <van-overlay :show="androidPromptShow" z-index="999" class="androidOverlay">
      <div>
        <div class="overlayContent" @click.stop>
          <div class="confirmBtnBox" @click="androidPromptShow = false"></div>
        </div>
      </div>
    </van-overlay>
    <!-- 苹果提示框 -->
    <van-overlay :show="iosPromptShow" z-index="999" class="iosOverlay">
      <div>
        <div class="overlayContent" @click.stop>
          <div class="confirmBtnBox" @click="iosPromptShow = false"></div>
        </div>
      </div>
    </van-overlay>
    <van-popup v-model="showTip" class="downTip">
      <div class="downTipTitle">温馨提示</div>
      <div class="downTipContent">
        请使用Safari浏览器进行下载
      </div>
      <div class="url">{{ currUrl }}</div>
      <div class="downTipConfirm" @click.stop="doCopy">复制链接</div>
    </van-popup>
  </div>
</template>

<script>
import { landingPageClick } from "@/utils/eventTracker";
import Title1 from "@/assets/images/mobile1/b/title1.webp";
import Title2 from "@/assets/images/mobile1/b/title2.webp";
import Title3 from "@/assets/images/mobile1/b/title3.webp";
import Hero1 from "@/assets/images/mobile1/b/hero1.webp";
import Hero2 from "@/assets/images/mobile1/b/hero2.webp";
import Hero3 from "@/assets/images/mobile1/b/hero3.webp";
import Gallery1 from "@/assets/images/mobile1/b/gallery1.webp";
import Gallery2 from "@/assets/images/mobile1/b/gallery2.webp";
import Gallery3 from "@/assets/images/mobile1/b/gallery3.webp";
export default {
  props: [
    "os",
    "version",
    "configs",
    "switchData",
    "shopIosDownUrl",
    "ip",
    "qrImg"
  ],
  data() {
    return {
      androidPromptShow: false,
      iosPromptShow: false,
      showTip: false,
      autoDownloadTriggered: false,
      currUrl: window.location.href,
      cTg: "",
      cPotato: "",
      cBusiness: "",
      cChannel: "",
      recordParam: "",
      slides: [
        {
          hero: Hero1,
          heroPos: {
            left: "2.933333%",
            top: "12.239583%",
            width: "86.133333%"
          },
          gallery: Gallery1,
          galleryPos: { left: "0", top: "1.692708%", width: "100%" }
        },
        {
          hero: Hero2,
          heroPos: {
            left: "0.266667%",
            top: "10.416667%",
            width: "106.4%"
          },
          gallery: Gallery2,
          galleryPos: { left: "0", top: "8.072917%", width: "100%" }
        },
        {
          hero: Hero3,
          heroPos: {
            left: "5.449067%",
            top: "10.994271%",
            width: "91.0296%"
          },
          gallery: Gallery3,
          galleryPos: { left: "0", top: "4.6875%", width: "100%" }
        }
      ],
      index: 0,
      timer: null,
      interval: 3600
    };
  },
  computed: {
    title() {
      return [Title1, Title2, Title3][this.index] || Title1;
    },
    contactItems() {
      return [
        {
          type: "business",
          label: "商务合作",
          url: this.cBusiness
        },
        {
          type: "channel",
          label: "渠道合作",
          url: this.cChannel
        },
        {
          type: "group",
          label: "官方群组",
          url: this.cTg
        }
      ].filter(item => item.url);
    },
    showSpareDownload() {
      return Boolean(
        !(this.os && this.os.isPhone) &&
          this.switchData &&
          this.switchData.androidDownUrl &&
          this.switchData.channelApkAndDownUrl
      );
    }
  },
  watch: {
    configs: {
      immediate: true,
      handler(configs = []) {
        this.cTg = "";
        this.cPotato = "";
        this.cBusiness = "";
        this.cChannel = "";
        configs.forEach(item => {
          if (item.configType === "tg_group") {
            this.cTg = item.link;
          } else if (item.configType === "potato_group") {
            this.cPotato = item.link;
          } else if (item.configType === "sw_cooperate") {
            this.cBusiness = item.link;
          } else if (item.configType === "qd_cooperate") {
            this.cChannel = item.link;
          }
        });
      }
    },
    switchData: {
      immediate: true,
      handler() {
        this.tryAutoDownload();
      }
    }
  },
  mounted() {
    if (!this.checkIsSafari() && this.os.isPhone) {
      this.showTip = true;
    }
    this.start();
  },
  beforeDestroy() {
    this.stop();
  },
  methods: {
    start() {
      this.stop();
      this.timer = setInterval(() => {
        this.next();
      }, this.interval);
    },
    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    next() {
      this.index = (this.index + 1) % this.slides.length;
    },
    pageClick(event) {
      let click_coordinates_x = event.clientX;
      let click_coordinates_y = event.clientY;
      landingPageClick(this, {
        click_coordinates_x,
        click_coordinates_y
      });
    },
    doCopy() {
      this.$copyText(this.currUrl).then(
        () => {
          this.showTip = false;
        },
        () => undefined
      );
    },
    checkIsSafari() {
      const ua = ((this.os && this.os.userAgent) || "").toLowerCase();
      // iOS 三方浏览器（Chrome/Firefox/Edge/Opera/夸克）UA 也带 Safari，需排除
      return (
        ua.indexOf("safari") !== -1 &&
        ua.indexOf("browser") === -1 &&
        ua.indexOf("android") === -1 &&
        ua.indexOf("crios") === -1 &&
        ua.indexOf("fxios") === -1 &&
        ua.indexOf("edgios") === -1 &&
        ua.indexOf("opios") === -1 &&
        ua.indexOf("quark") === -1
      );
    },
    // 下载数据就绪后，按当前系统自动触发一次下载
    tryAutoDownload() {
      if (this.autoDownloadTriggered) return;
      // 仅落地页带渠道码 ?dc=xxx 时才自动下载
      if (!this.$route.query.dc) return;
      const data = this.switchData || {};
      const isIos = this.os && this.os.isPhone;
      // 安卓仅在渠道包地址存在时才自动下载
      const downUrl = isIos ? data.iosDownUrl : data.channelApkAndDownUrl;
      if (!downUrl) return;
      // iOS 非 Safari 浏览器无法下载，已弹 Safari 提示，不自动触发
      if (isIos && !this.checkIsSafari()) return;
      this.autoDownloadTriggered = true;
      this.fireWhenPageLoaded(() => {
        // 下载立即触发，安装教程弹窗延迟 5s 再弹出
        this.downloadByType(isIos ? "ios" : "android", null, 5000);
      });
    },
    // 等页面资源加载完成再执行，避免下载跳转把加载中的图片全部中断
    fireWhenPageLoaded(fn) {
      if (document.readyState === "complete") {
        fn();
        return;
      }
      let fired = false;
      const fire = () => {
        if (fired) return;
        fired = true;
        window.removeEventListener("load", fire);
        fn();
      };
      window.addEventListener("load", fire);
      // 兜底：弱网下资源迟迟加载不完也要触发下载
      setTimeout(fire, 10000);
    },
    async showInstallTutorial(type) {
      if (type == "ios") {
        this.iosPromptShow = true;
      } else {
        this.androidPromptShow = true;
      }
    },
    async downloadByType(type, event, tutorialDelay = 0) {
      this.$toast("应用正在下载中，十秒后无反应请再次点击下载！");
      this.$emit("getApkInfoApi", type);
      if (tutorialDelay) {
        setTimeout(() => {
          this.showInstallTutorial(type);
        }, tutorialDelay);
      } else {
        await this.showInstallTutorial(type);
      }
      setTimeout(() => {
        this.$emit("getApkInfo", type);
      }, 500);
      this.recordDownloadClick(event);
    },
    recordDownloadClick(event) {
      if (!event) {
        return;
      }
      let click_coordinates_x = event.clientX;
      let click_coordinates_y = event.clientY;
      landingPageClick(this, {
        tab_name: "下载按钮",
        tab_key: "download",
        click_coordinates_x,
        click_coordinates_y
      });
    },
    async getApkInfo(flag, event) {
      let type = "android";
      if (flag) {
        type = "iosShop";
      } else if (this.os.isPhone) {
        type = "ios";
      }
      this.$emit("getApkInfoApi", type);
      if (type != "iosShop") {
        await this.showInstallTutorial(type);
      }
      setTimeout(() => {
        this.$emit("getApkInfo", type);
      }, 500);
      this.recordDownloadClick(event);
    },
    // 备用下载
    async onSpare(event) {
      let type = "androidSpare";
      this.$emit("getApkInfoApi", type);
      await this.showInstallTutorial(type);
      setTimeout(() => {
        this.$emit("getApkInfo", type);
      }, 500);
      this.recordDownloadClick(event);
    },
    jumpUrl(url) {
      window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile-b-page {
  height: 100dvh;
  width: 100%;
  background-color: #4bb6e8;
  background-image: url("./../../../assets/images/pc1/b/bg.webp");
  background-position: 57.47% center;
  background-repeat: no-repeat;
  background-size: auto 100%;
  overflow: hidden;
  position: relative;

  // 舞台始终落在安全区内；宽屏按可用高度收窄，矮屏按视口宽度收高。
  .mb-stage {
    position: absolute;
    top: calc(
      env(safe-area-inset-top) +
        (100dvh - env(safe-area-inset-top) - env(safe-area-inset-bottom)) / 2
    );
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    background-color: #4bb6e8;
    background-image: url("./../../../assets/images/pc1/b/bg.webp");
    background-position: 57.47% center;
    background-repeat: no-repeat;
    background-size: auto 100%;
    overflow: hidden;
  }

  .mb-carousel {
    position: absolute;
    inset: 0;
    z-index: 10;
    overflow: hidden;

    .mb-slide {
      height: 100%;
      left: 0;
      opacity: 0;
      position: absolute;
      top: 0;
      transition: opacity 1s ease;
      width: 100%;
      z-index: 1;
    }

    .mb-slide.active {
      opacity: 1;
      z-index: 2;
    }

    .mb-slide img {
      display: block;
      pointer-events: none;
      position: absolute;
      object-fit: contain;
    }

    .mb-gallery {
      z-index: 1;
    }

    .mb-hero {
      z-index: 2;
    }
  }

  .mb-title,
  .mb-deco-fruit,
  .mb-subtitle,
  .mb-catalog {
    position: absolute;
    display: block;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    pointer-events: none;
  }

  .mb-title {
    left: 5.597333%;
    top: 43.098958%;
    width: 92.016%;
    height: 22.401042%;
    object-fit: cover;
    z-index: 30;
  }

  .mb-deco-fruit {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 29.427083%;
    background: url("./../../../assets/images/mobile1/b/deco-fruit.webp") bottom / cover no-repeat;
    z-index: 15;
  }

  .mb-subtitle {
    left: 0.266667%;
    top: 61.216146%;
    width: 97.957333%;
    height: 8.315104%;
    background-image: url("./../../../assets/images/mobile1/b/subtitle.webp");
    z-index: 30;
  }

  .mb-catalog {
    left: 11.466667%;
    top: 67.317708%;
    width: 79.5296%;
    height: 22.526042%;
    background-image: url("./../../../assets/images/pc1/b/catalog.webp");
    z-index: 25;
  }

  .mb-logo {
    position: absolute;
    top: 1.101563%;
    left: 3.866667%;
    width: 61.622667%;
    height: 8.208984%;
    background: url("./../../../assets/images/mobile1/b/logo.webp") no-repeat
      left center;
    background-size: contain;
    z-index: 100;
  }

  .mb-contact-list {
    position: absolute;
    top: 2.167969%;
    right: 4.0888%;
    width: 30.844533%;
    height: 5.46875%;
    display: flex;
    align-items: stretch;
    justify-content: flex-end;
    gap: 15.56196%;
    z-index: 100;

    .mb-contact-button {
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      height: 100%;
      &.business {
        background-image: url("./../../../assets/images/mobile1/b/contact-business.png");
        flex: 0 0 22.478386%;
      }
      &.channel {
        background-image: url("./../../../assets/images/mobile1/b/contact-channel.png");
        flex: 0 0 23.342939%;
      }
      &.group {
        background-image: url("./../../../assets/images/mobile1/b/contact-group.png");
        flex: 0 0 23.054755%;
      }
    }
  }

  .mb-download-actions {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 16.266667%;
    top: 88.932292%;
    width: 67.733333%;
    height: 9.505208%;
    z-index: 100;

    .mb-download-button {
      background-image: url("./../../../assets/images/mobile1/b/download.webp");
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      width: 100%;
      height: 100%;
    }
  }

  .hotspot {
    appearance: none;
    border: 0;
    background: transparent;
    cursor: pointer;
    display: block;
    padding: 0;
    -webkit-tap-highlight-color: transparent;
  }

  .androidOverlay {
    display: flex;
    align-items: center;
    justify-content: center;
    .overlayContent {
      width: 297px;
      height: 441px;
      background: url("./../../../assets/images/mobile1/androidTip.png")
        no-repeat;
      background-size: 100% 100%;
      border-radius: 12px;
      padding-top: 380px;
      .confirmBtnBox {
        height: 33px;
        width: 128px;
        border-radius: 40px;
        margin: 0 auto;
      }
    }
  }
  .iosOverlay {
    display: flex;
    align-items: center;
    justify-content: center;
    .overlayContent {
      width: 297px;
      height: 441px;
      background: url("./../../../assets/images/mobile1/iosTip.png") no-repeat;
      background-size: 100% 100%;
      border-radius: 12px;
      padding-top: 380px;
      .confirmBtnBox {
        height: 33px;
        width: 128px;
        border-radius: 40px;
        margin: 0 auto;
      }
    }
  }
}
.downTip {
  border-radius: 10px;
  padding: 18px;
  box-sizing: border-box;
  text-align: center;
  .downTipTitle {
    font-size: 18px;
    margin-bottom: 34px;
  }
  .downTipContent {
    white-space: nowrap;
    font-size: 15px;
  }
  .url {
    font-size: 15px;
    margin-top: 16px;
    text-align: left;
  }
  .downTipConfirm {
    font-size: 15px;
    width: 160px;
    height: 30px;
    border-radius: 40px;
    margin: 32px auto 0;
    color: #fff;
    background: #5b92ee;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
